import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Entero limpio: bloquea no-dígitos, respeta min/max y devuelve number|null al onChange.
export const NumberField = React.forwardRef(
  ({ value, onChange, min, max, className, ...props }, ref) => {
    const handle = (e) => {
      const v = e.target.value.replace(/[^0-9]/g, "");
      if (v === "") return onChange?.(null);
      let n = parseInt(v, 10);
      if (typeof max === "number" && n > max) n = max;
      if (typeof min === "number" && n < min) n = min;
      onChange?.(n);
    };
    return (
      <Input
        ref={ref}
        inputMode="numeric"
        value={value == null ? "" : String(value)}
        onChange={handle}
        className={cn("font-mono", className)}
        {...props}
      />
    );
  }
);
NumberField.displayName = "NumberField";
